// src/data/financial.ts
// Financial propensity signals from the SIG Financial data layer
// 475M records with credit, income, and intent signals

export interface FinancialPropensitySignal {
  id: string;
  name: string;
  description: string;
  coverage: number;      // number of records with this signal
  coveragePct: number;   // percentage of 475M financial base
  audienceUseCase: string;
}

export const financialSignals: FinancialPropensitySignal[] = [
  {
    id: 'auto_loan_intent',
    name: 'Automotive Loan Intent',
    description: 'Likely to open a new or refinanced auto loan or lease in next 90 days',
    coverage: 224_259_778,
    coveragePct: 0.471,
    audienceUseCase: 'Combine with Auto intent topics for high-conversion auto dealer campaigns',
  },
  {
    id: 'auto_offer_response',
    name: 'Auto Offer Response',
    description: 'Likely to respond to an automobile offer within the next 90 days',
    coverage: 164_377_692,
    coveragePct: 0.346,
    audienceUseCase: 'Target with OEM and dealer promotions — proven responders',
  },
  {
    id: 'card_offer_response',
    name: 'Card Offer Response',
    description: 'Likely to respond to a credit/bank card offer within the next 90 days',
    coverage: 190_788_581,
    coveragePct: 0.401,
    audienceUseCase: 'Financial services targeting — pair with Banking intent topics',
  },
  {
    id: 'bank_card_intent',
    name: 'Bank Card Intent',
    description: 'Likely to open a new bank card or credit card account',
    coverage: 47_496_991,
    coveragePct: 0.100,
    audienceUseCase: 'High-value financial services audience — active card seekers',
  },
  {
    id: 'mortgage_new_intent',
    name: 'New Mortgage Intent',
    description: 'Likely to open a new first mortgage (excluding refinance)',
    coverage: 8_056_895,
    coveragePct: 0.017,
    audienceUseCase: 'Real Estate + Home Improvement cross-sell — new homebuyers',
  },
  {
    id: 'mortgage_refi_intent',
    name: 'Mortgage Refinance Intent',
    description: 'Likely to refinance existing mortgage',
    coverage: 16_113_790,
    coveragePct: 0.034,
    audienceUseCase: 'Mortgage lender targeting — rate-sensitive homeowners',
  },
];

export const creditTiers = [
  { range: '750-799', count: 133_823_152, pct: 0.285, label: 'Excellent' },
  { range: '700-749', count: 153_329_520, pct: 0.327, label: 'Good' },
  { range: '650-699', count: 89_000_000, pct: 0.190, label: 'Fair' },
  { range: '600-649', count: 52_000_000, pct: 0.111, label: 'Below Average' },
  { range: 'Below 600', count: 47_000_000, pct: 0.087, label: 'Subprime' },
];

export const incomeRanges = [
  { range: '$150K+', count: 42_000_000, pct: 0.089 },
  { range: '$100K-$150K', count: 68_000_000, pct: 0.143 },
  { range: '$75K-$100K', count: 85_000_000, pct: 0.179 },
  { range: '$50K-$75K', count: 92_000_000, pct: 0.194 },
  { range: '$35K-$50K', count: 67_000_000, pct: 0.141 },
  { range: 'Below $35K', count: 121_000_000, pct: 0.254 },
];
